function _(n,t,a){var l=n(113),_=function(n){function t(t){return n.call(this,t)||this}return l.__extends(t,n),t}(n(166).Model);a.Callback=_,_.__name__="Callback"}
//# sourceMappingURL=callback.min.js.map